import React from "react";

const License: React.FC = () => (
    <em>
        An unlimited, perpetual license to reproduce this copyrighted text without attribution is granted to governmental entities for purposes of research, administration, and legislative activity. A limited license, requiring attribution, is granted to all other entities.
    </em>
);

export default License;